import {
  elseware_games,
  incbotic,
  lseg,
  maggiesfarm_studio,
  ucsc,
  wso2,
} from "src/assets";

export const SOFTWARE_PROJECTS = [
  {
    title: "elseware UI",
    associatedWith: "elseware Games",
    logo: elseware_games,
    description:
      "A React component library built for elseware Games projects, providing reusable and customizable UI components.",
    tech: ["React", "Storybook", "Rollup", "TypeScript", "Tailwind CSS"],
    links: [
      {
        text: "NPM Package",
        link: "https://www.npmjs.com/package/elseware-ui",
      },
    ],
  },
  {
    title: "elseware Games Official Website",
    associatedWith: "elseware Games",
    logo: elseware_games,
    description:
      "Official website for elseware Games to publish PC and mobile games developed by elseware™ Games. It serves as a hub for showcasing game titles, updates, and community engagement.",
    tech: ["MERN Stack", "Render", "MongoDB Atlas", "Vercel", "Postman"],
    links: [
      {
        text: "Website",
        link: "https://www.elsewaregames.com/",
      },
    ],
  },
  {
    title: "Incbotic (Pvt) Ltd. Official Website",
    associatedWith: "IncBotic",
    logo: incbotic,
    description:
      "Official website of Incbotic (Pvt) Ltd to showcase their products and services.",
    tech: [
      "Microservices",
      "React",
      "Typescript",
      "Tailwind CSS",
      "Ant Designs",
      "NodeJS",
      "Molecular Framework",
      "AWS",
      "Keycloak",
      "PostgreSQL",
      "Amazon DBS3",
    ],
    links: [
      {
        text: "Website",
        link: "https://incbotic.com/",
      },
    ],
  },
  {
    title: "c-webserver",
    associatedWith: "University of Colombo School of Computing",
    logo: ucsc,
    description:
      "A basic web server built from scratch using C, supporting HTTP GET requests with error handling.",
    tech: ["C", "HTTP", "Makefile", "Sockets"],
    links: [
      {
        text: "Repository",
        link: "https://github.com/DhanushkaSandakelum/c-webserver",
      },
    ],
  },
  {
    title: "Software-Defined Computer Network Simulator",
    associatedWith: "University of Colombo School of Computing",
    logo: ucsc,
    description:
      "A network simulation tool built using Mininet to model and test software-defined networking (SDN) concepts. The simulator allows users to create virtual networks, test routing protocols, and evaluate SDN controllers.",
    tech: ["Mininet", "Python", "OpenFlow", "SDN", "Linux", "Wireshark"],
    links: [
      {
        text: "Repository",
        link: "https://github.com/DhanushkaSandakelum/sdn-simulator",
      },
    ],
  },
  {
    title: "React Sorting Visualizer",
    associatedWith: "Independent Project",
    logo: null,
    description:
      "A web-based visualization tool for understanding sorting algorithms. It demonstrates various sorting techniques such as Bubble Sort, Merge Sort, Quick Sort, and more in an interactive manner.",
    tech: [
      "React",
      "Redux Toolkit",
      "Tailwind CSS",
      "JavaScript",
      "classnames",
    ],
    links: [
      {
        text: "Repository",
        link: "https://github.com/DhanushkaSandakelum/react-sorting-visualizer",
      },
    ],
  },
  {
    title: "XV6 Operating System Improvements",
    associatedWith: "University of Colombo School of Computing",
    logo: ucsc,
    description:
      "Referring to the XV6 operating system to understand core concepts such as process management, memory management, and system internals. Contributed to improving the existing open-source codebase of MIT XV6.",
    tech: ["C", "XV6", "Operating System Concepts"],
    links: [
      {
        text: "Repository",
        link: "https://github.com/DhanushkaSandakelum/xv6",
      },
    ],
  },
  {
    title: "Java Design Patterns",
    associatedWith: "Independent Project",
    logo: null,
    description:
      "An open-source project created to understand and demonstrate various design patterns in Java. The repository provides explanations, code examples, and practical applications for Creational, Structural, and Behavioral patterns like Memento, State, and Iterator.",
    tech: ["Java", "Design Patterns", "OOP"],
    links: [
      {
        text: "Repository",
        link: "https://github.com/DhanushkaSandakelum/DesignPatterns",
      },
    ],
  },
  {
    title: "Javascript Advanced Concepts",
    associatedWith: "Independent Project",
    logo: null,
    description:
      "An open-source project aimed at mastering advanced JavaScript concepts and patterns. This repository demonstrates various programming techniques such as asynchronous programming, closures, promises, and advanced functional programming. It also includes practical implementations and real-world examples for key JavaScript concepts.",
    tech: [
      "JavaScript",
      "Asynchronous Programming",
      "Design Patterns",
      "Functional Programming",
      "OOP",
    ],
    links: [
      {
        text: "Repository",
        link: "https://github.com/DhanushkaSandakelum/javascript",
      },
    ],
  },
  {
    title: "go-mongo-restapi",
    associatedWith: "Independent Project",
    logo: null,
    description:
      "A fully functional backend service built with Golang and MongoDB. It provides a REST API with various endpoints for handling CRUD operations, designed for scalability and efficiency.",
    tech: ["Golang", "MongoDB", "REST API", "Docker"],
    links: [
      {
        text: "Repository",
        link: "https://github.com/DhanushkaSandakelum/go-mongo-restapi",
      },
    ],
  },
  {
    title: "Ballerina HL7 model generator tool",
    associatedWith: "WSO2",
    logo: wso2,
    description:
      "Automated tool to generate Ballerina packages for HL7 specs, eliminating repetitive manual coding.",
    tech: ["Ballerina", "Java", "HL7", "Codegen Framework"],
  },
  {
    title: "Choreo visual data mapper for healthcare message formats",
    associatedWith: "WSO2",
    logo: wso2,
    description:
      "Developed a visual data mapping feature for transforming complex FHIR healthcare data structures.",
    tech: ["FHIR", "Ballerina", "Choreo", "Data Transformation"],
  },
  {
    title: "Online Student Selection System",
    associatedWith: "University of Colombo School of Computing",
    logo: ucsc,
    description:
      "A web application for resolving the existing problems associating with the official government university registration process.",
    tech: [
      "Spring Boot",
      "JWT",
      "Spring Security",
      "Eureka Server",
      "Cloud API",
      "RabbitMQ",
      "React",
      "MySQL",
      "MongoDB",
      "AWS",
      "Blockchain",
    ],
  },
  {
    title: "Whiz™",
    associatedWith: "University of Colombo School of Computing",
    logo: ucsc,
    description:
      "Whiz™ is a web-based platform designed to help students make informed decisions, connect companies with potential candidates, and enable professional guiders and teachers to share knowledge. It also provides universities a platform to communicate course offerings and intake information.",
    tech: ["React", "Node.js", "MongoDB", "Express", "Firebase"],
  },
  {
    title: "Virtual Village",
    associatedWith: "Independent Project",
    logo: null,
    description:
      "An experimental Unreal Engine project showcasing UE4’s capabilities, focusing on environment design, AI integration, and character animation to deliver an immersive and visually optimized experience.",
    tech: [
      "Unreal Engine",
      "Blender",
      "Mixamo",
      "AI Integration",
      "3D Modeling",
      "Animation",
    ],
    links: [
      {
        text: "Repository",
        link: "https://github.com/DhanushkaSandakelum/VirtualVillageUE4",
      },
    ],
  },
  {
    title: "EMPTUM - A collaborative shopping platform",
    associatedWith: "Independent Project",
    logo: null,
    description:
      "EMPTUM is a collaborative shopping platform built with NodeJS and React, featuring a microservice architecture. It streamlines item management, payments, deliveries, and communication, offering scalability and real-time updates for an enhanced shopping experience.",
    tech: [
      "NodeJS",
      "React",
      "MySQL",
      "Java 17",
      "Gitbash",
      "Postman",
      "Eureka Server",
      "Spring Boot",
    ],
    links: [
      {
        text: "Repository",
        link: "https://github.com/DhanushkaSandakelum/collaborative-shopping-platform",
      },
    ],
  },
  {
    title: "ThreeJS based simulations",
    associatedWith: "Independent Project",
    logo: null,
    description:
      "A collection of interactive simulations created using ThreeJS, showcasing various visual effects, camera controls, and 3D models. The project includes simulations like rotating cubes, camera perspectives, star fields, snow effects, and more, designed to explore and demonstrate the capabilities of ThreeJS in creating immersive web-based 3D experiences.",
    tech: ["ThreeJS", "WebGL", "JavaScript"],
    links: [
      {
        text: "Repository",
        link: "https://github.com/DhanushkaSandakelum/game-development",
      },
    ],
  },
];
